<div class='track'>
  <div class='fill' [style.width]='fillWidthStyle' [class.loading]="isIndeterminateLoading"></div>
</div>
